import * as swcHelpers from '@swc/helpers';
import { DataLayer, calcPrice } from '@grandvisionhq/analytics';

const getSubscriptionType = (lineItem)=>{
    return lineItem.type === 'contact-lenses-bundle-benelux' ? DataLayer.DataLayerTypes.PurchaseType.CLBBSubscription : DataLayer.DataLayerTypes.PurchaseType.OneTime;
};
const getNameFromBrand = (brand)=>{
    const name = [
        ...new Set([
            brand.name,
            brand.model,
            brand.modelCode
        ].filter(Boolean))
    ].join(' ').trim();
    return name;
};
const getSharedAttributes = (lineItem, lineItemType, quantity = 1)=>{
    const { brand , sku , price  } = lineItem;
    return {
        name: getNameFromBrand(brand),
        id: sku,
        price: calcPrice(price.unit.gross),
        dimension143: getSubscriptionType(lineItem),
        dimension144: lineItemType,
        dimension145: 'true',
        dimension190: lineItem.erpId || '',
        metric140: calcPrice(price.unit.original),
        metric141: calcPrice(price.unit.discount),
        metric142: calcPrice(price.unit.taxAmount),
        quantity
    };
};
const getSunglassesAttributes = (lineItem, quantity)=>{
    var ref, ref1, ref2;
    const { brand , frame , gender , sku  } = lineItem;
    const genderValue = gender && gender.map((value)=>value.toLowerCase()
    ).join();
    return swcHelpers.objectSpread({}, getSharedAttributes(lineItem, DataLayer.DataLayerTypes.LineItemType.Single, quantity), {
        category: DataLayer.DataLayerTypes.Category.Sunglasses,
        brand: brand.name || '',
        variant: (frame === null || frame === void 0 ? void 0 : (ref = frame.frameShape) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || '',
        dimension16: genderValue || '',
        dimension140: sku,
        dimension146: (frame === null || frame === void 0 ? void 0 : (ref1 = frame.frameMaterial) === null || ref1 === void 0 ? void 0 : ref1.join().toLowerCase()) || '',
        dimension147: (frame === null || frame === void 0 ? void 0 : (ref2 = frame.frameColor) === null || ref2 === void 0 ? void 0 : ref2.join().toLowerCase()) || ''
    });
};
const getReadyReadersAttributes = (lineItem, quantity = 1)=>{
    var ref, ref3, ref4;
    const { brand , frame , gender , sku  } = lineItem;
    const genderValue = gender && gender.map((value)=>value.toLowerCase()
    ).join();
    return swcHelpers.objectSpread({}, getSharedAttributes(lineItem, DataLayer.DataLayerTypes.LineItemType.Single, quantity), {
        category: DataLayer.DataLayerTypes.Category.ReadyReaders,
        brand: brand.name || '',
        variant: (frame === null || frame === void 0 ? void 0 : (ref = frame.frameShape) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || '',
        dimension16: genderValue || '',
        dimension140: sku,
        dimension146: (frame === null || frame === void 0 ? void 0 : (ref3 = frame.frameMaterial) === null || ref3 === void 0 ? void 0 : ref3.join().toLowerCase()) || '',
        dimension147: (frame === null || frame === void 0 ? void 0 : (ref4 = frame.frameColor) === null || ref4 === void 0 ? void 0 : ref4.join().toLowerCase()) || ''
    });
};
const getAccessoriesLineItem = (lineItem, quantity = 1)=>{
    const { brand , accessoryType , accessoryColor , material , gender , sku  } = lineItem;
    const genderValue = gender && gender.map((value)=>value.toLowerCase()
    ).join();
    return swcHelpers.objectSpread({}, getSharedAttributes(lineItem, DataLayer.DataLayerTypes.LineItemType.Single, quantity), {
        category: DataLayer.DataLayerTypes.Category.Accessories,
        brand: brand.name || '',
        variant: accessoryType || '',
        dimension16: genderValue || '',
        dimension140: sku,
        dimension146: material || '',
        dimension147: (accessoryColor === null || accessoryColor === void 0 ? void 0 : accessoryColor.join().toLowerCase()) || ''
    });
};
const getContactLensesAttributes = (lineItem, quantity)=>{
    var ref;
    return swcHelpers.objectSpread({}, getSharedAttributes(lineItem, DataLayer.DataLayerTypes.LineItemType.Single, quantity), {
        name: lineItem.name,
        category: DataLayer.DataLayerTypes.Category.ContactLenses,
        brand: lineItem.brand.name || '',
        variant: lineItem.lensType || '',
        dimension140: lineItem.sku,
        dimension146: lineItem.material || '',
        dimension148: ((ref = lineItem.replacementFrequency) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || ''
    });
};
const getSolutionsAttributes = (lineItem, quantity)=>swcHelpers.objectSpread({}, getSharedAttributes(lineItem, DataLayer.DataLayerTypes.LineItemType.Single, quantity), {
        name: lineItem.name,
        category: DataLayer.DataLayerTypes.Category.Solutions,
        brand: lineItem.brand.name || '',
        variant: lineItem.solutionVolume + 'ml',
        dimension140: lineItem.sku,
        dimension146: lineItem.solutionType
    })
;
const getContactLensesBundleBeneluxAttributes = (lineItem, quantity)=>swcHelpers.objectSpread({}, getSharedAttributes(lineItem, DataLayer.DataLayerTypes.LineItemType.Bundle, quantity), {
        category: DataLayer.DataLayerTypes.Category.ContactLenses,
        variant: lineItem.lensType
    })
;
const getPrescriptionGlassesAttributes = (lineItem, quantity = 1)=>{
    var ref;
    const { frame , price , productType  } = lineItem;
    const { brand  } = frame;
    const category = productType === 'sunglasses' ? DataLayer.DataLayerTypes.Category.Sunglasses : DataLayer.DataLayerTypes.Category.Optical;
    const name = getNameFromBrand(brand);
    return {
        category,
        name,
        brand: frame.brand.name || '',
        id: frame.sku,
        price: calcPrice(price.unit.gross),
        variant: ((ref = frame.frameShape) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || '',
        dimension16: frame.gender || '',
        dimension140: frame.sku,
        dimension143: getSubscriptionType(lineItem),
        dimension144: DataLayer.DataLayerTypes.LineItemType.Bundle,
        dimension145: 'true',
        dimension146: frame.frameMaterial || '',
        dimension147: frame.frameColor || '',
        dimension190: lineItem.erpId || '',
        metric140: calcPrice(price.unit.original),
        metric141: calcPrice(price.unit.discount),
        metric142: calcPrice(price.unit.taxAmount),
        quantity
    };
};
const mapClientModelToProductObject = (lineItem, quantity)=>{
    switch(lineItem.type){
        case 'sunglasses':
            return getSunglassesAttributes(lineItem, quantity);
        case 'contact-lenses':
            return getContactLensesAttributes(lineItem, quantity);
        case 'solutions':
            return getSolutionsAttributes(lineItem, quantity);
        case 'contact-lenses-bundle-benelux':
            return getContactLensesBundleBeneluxAttributes(lineItem, quantity);
        case 'prescription-glasses':
            return getPrescriptionGlassesAttributes(lineItem, quantity);
        case 'ready-readers':
            return getReadyReadersAttributes(lineItem, quantity);
        case 'accessories':
            return getAccessoriesLineItem(lineItem, quantity);
        default:
            return undefined;
    }
};

export { mapClientModelToProductObject };
//# sourceMappingURL=client-model-to-product-object.js.map
